import React from 'react';
import { Card, Typography, Box, Stack } from '@mui/material';
import { getDate } from '../features/Bookings/utils';

function SubscriptionCard({ title, city, sessionsLeft, freeCancellations, dueDate }) {
  return (
    <Card sx={{ p: 2, borderRadius: 2, boxShadow: 1, mb: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography
          variant='h6'
          sx={{ fontSize: 16, fontWeight: 'bold' }}
        >
          {title}
        </Typography>
      </Box>

      <Box sx={{ mt: 2 }}>
        <Stack
          direction='row'
          alignItems='center'
          gap={1}
          sx={{ mt: 1 }}
        >
          <Typography sx={{ fontSize: 14, color: 'text.secondary' }}>{city}</Typography>
        </Stack>
        <Stack
          direction='row'
          alignItems='center'
          gap={1}
          sx={{ mt: 1 }}
        >
          <Typography sx={{ fontSize: 14, color: 'text.secondary' }}>
            Посещения: {sessionsLeft}
          </Typography>
        </Stack>
        <Typography sx={{ fontSize: 14, color: 'text.secondary' }}>
          Бесплатные отмены: {freeCancellations}
        </Typography>
        <Typography sx={{ fontSize: 14, color: 'text.secondary' }}>
          Действует до: {getDate(dueDate)}
        </Typography>
      </Box>
    </Card>
  );
}

export default SubscriptionCard;
